const calculateExpectedHin = (scope, sanitizedHin) => {
  const nameLetters = (_.padEnd(_.deburr(scope.patientModel.lastName).trim().replace(/[^A-Za-z]/, ''), 3, 'X').substr(0, 3) + _.deburr(scope.patientModel.firstName).trim().replace(/[^A-Za-z]/, '')[0]).toUpperCase();
  const lastDigits = sanitizedHin.substr(10, 2);
  let birthdateDigits = moment(scope.patientModel.birthdate, 'YYYY-MM-DD').format('YYMMDD');

  // Handle the case of a female patient, add 5 to the third digit
  if (scope.patientModel.gender === 'female') {
    const genderDigit = parseInt(birthdateDigits[2]) + 5;
    birthdateDigits = birthdateDigits.substr(0, 2) + genderDigit + birthdateDigits.substr(3);
  }

  const expectedHin = nameLetters + birthdateDigits + lastDigits;
  return expectedHin;
};

const validateHinFormat = (hin, manitoba) => {
  if (manitoba) {
    return !/^[0-9]{9}$/.test(hin);
  }

  return !/^[a-zA-Z]{4}\s?[0-9]{4}\s?[0-9]{4}$/.test(hin);
};

const sumManitobaHinCoefficients = (hinArray) => {
  const coefficientMap = {
    0: 29,
    1: 23,
    2: 19,
    3: 17,
    4: 13,
    5: 7,
    6: 5,
    7: 3,
  };
  let sum = 0;

  hinArray.forEach((digit, idx) => {
    if (idx !== 8) {
      sum += digit * coefficientMap[idx];
    }
  });

  return sum;
};

function validManitobaHin(hin) {
  if (hin.length === 9) {
    const sum = sumManitobaHinCoefficients(hin.split(''));
    const validLastDigit = (sum % 11) % 10;
    return validLastDigit === Number(hin[8]);
  }
  return null;
}

module.exports = () => ({
  scope: {
    hinValidation: '<',
    patientModel: '<',
  },
  restrict: 'A',
  require: 'ngModel',
  link: (scope, element, attrs, ctrl) => {
    // Add a parser that will process each time the value is parsed into the model when the user updates it
    ctrl.$parsers.unshift((hin) => {
      if (hin && scope.hinValidation !== false) {
        // Validate basic pattern match, i.e. ABCD 0123 4567 with spaces optional
        if (validateHinFormat(hin, scope.patientModel.manitoba)) {
          ctrl.$setValidity('format', false);
          return;
        }

        if (scope.patientModel.manitoba) {
          if (!validManitobaHin(hin)) {
            ctrl.$setValidity('format', false);
            return;
          }
        }

        if (!scope.patientModel.manitoba && scope.patientModel.firstName && scope.patientModel.lastName && scope.patientModel.birthdate && scope.patientModel) {
          // The HIN format is based on first name, last name gender and birthdate - so all 4 must be present for the full validation if not Manitoba
          // Sanitize the value (as will be done server-side)
          const sanitizedHin = hin.replace(/\s/g, '').trim().toUpperCase();
          const expectedHin = calculateExpectedHin(scope, sanitizedHin);

          if (sanitizedHin !== expectedHin) {
            ctrl.$setValidity('format', false);
            return;
          }
        }

        ctrl.$setValidity('format', true);
      }
      return hin;
    });
  },
});



// WEBPACK FOOTER //
// ./main/directives/hin-validation.js